/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_Duration_LblInputs */

const es_cap_jpc_duration_lbl = /** @type {(inputs: Cap_Jpc_Duration_LblInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const gl_cap_jpc_duration_lbl = /** @type {(inputs: Cap_Jpc_Duration_LblInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const en_cap_jpc_duration_lbl = /** @type {(inputs: Cap_Jpc_Duration_LblInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Cap_Jpc_Duration_LblInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_duration_lbl = /** @type {((inputs?: Cap_Jpc_Duration_LblInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_Duration_LblInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_duration_lbl(inputs)
	if (locale === "en") return en_cap_jpc_duration_lbl(inputs)
	return es_cap_jpc_duration_lbl(inputs)
});